<template>
  <div class="dpl">
    <span class="dpl-count">{{ summary }}</span>
    <Tooltip v-if="perPage" :text="$t('dash.overview.dashboards.pages_with_data_help')" position="bottom">
      <span class="dpl-legend"><span class="dpl-dot"></span>{{ $t('dash.overview.dashboards.pages_with_data', { count: withDataCount }) }}</span>
    </Tooltip>
    <!-- Avatars en boule, icône du réseau en bas à droite (comme ailleurs), pastille verte = statistiques sur la période ; au-delà de MAX, « +N » liste les autres -->
    <div v-if="pages.length" class="dpl-avatars">
      <Tooltip v-for="page in shown" :key="page.id" :text="pageLabel(page)" position="bottom">
        <span class="dpl-avatar">
          <PageImageAvatar :page="page" />
          <span v-if="hasData(page)" class="dpl-dot dpl-dot--avatar"></span>
        </span>
      </Tooltip>
      <Tooltip v-if="hidden.length" :text="hiddenLabel" position="bottom">
        <button class="ov-dpl-more" @click="expanded = true">+{{ hidden.length }}</button>
      </Tooltip>
      <button v-if="expanded && pages.length > max" class="ov-arrow-link dpl-less" @click="expanded = false">{{ $t('dash.overview.dashboards.hide_pages') }}</button>
    </div>
  </div>
</template>

<script>
import Tooltip from '../../tooltip/tooltipInit.vue'
import PageImageAvatar from '../../PageImageAvatar.vue'
import { isReportingEligible } from '@/utils/reportingEligibility'

const MAX = 12

/**
 * Pages d'un tableau de bord personnalisé : nombre, avatars (icône du réseau en bas à droite) et « +N » pour le reste
 */
export default {
  name: 'DashboardPagesList',

  components: { Tooltip, PageImageAvatar },

  props: {
    pages: { type: Array, default: () => [] },
    // Aucune page choisie : toutes les pages accessibles (y compris celles ajoutées plus tard)
    allPages: { type: Boolean, default: false },
    // per_page de /reporting/overview (has_data : statistiques sur la période) ; null tant qu'il n'est pas chargé
    perPage: { type: Array, default: null }
  },

  data() {
    return { expanded: false, max: MAX }
  },

  computed: {
    summary() {
      const count = this.pages.length
      return this.allPages ? this.$t('dash.overview.dashboards.all_pages', { count }) : this.$t('dash.overview.dashboards.pages_count', { count })
    },

    shown() {
      return this.expanded ? this.pages : this.pages.slice(0, MAX)
    },

    hidden() {
      return this.expanded ? [] : this.pages.slice(MAX)
    },

    withData() {
      return new Set((this.perPage || []).filter(p => p.has_data).map(p => String(p.id)))
    },

    withDataCount() {
      return this.pages.filter(p => this.hasData(p)).length
    },

    hiddenLabel() {
      return this.hidden.map(p => this.pageLabel(p)).join(', ')
    }
  },

  methods: {
    isEligible(page) {
      return isReportingEligible(page)
    },

    hasData(page) {
      return this.withData.has(String(page.id))
    },

    // Nom, réseau et état des statistiques (une fois l'overview chargé)
    pageLabel(page) {
      const network = this.$t(`dash.overview.network.${page.network}`)
      let state = ''
      if (!this.isEligible(page)) state = this.$t('dash.overview.dashboards.out_of_reporting')
      else if (this.perPage) state = this.$t(this.hasData(page) ? 'dash.overview.dashboards.page_has_data' : 'dash.overview.dashboards.page_no_data')
      return `${page.name} (${network})${state ? ` · ${state}` : ''}`
    }
  }
}
</script>

<style scoped>
.dpl {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 12px;
}
.dpl-count {
  font-size: 13px;
  color: #555e75;
}
.dpl-avatars {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}
.dpl-avatar {
  position: relative;
  display: inline-flex;
  transition: transform 0.15s;
}
/* Pastille verte : statistiques disponibles sur la période */
.dpl-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #1a9e5e;
}
.dpl-dot--avatar {
  position: absolute;
  top: -1px;
  right: -1px;
  width: 10px;
  height: 10px;
  box-shadow: 0 0 0 2px #fff;
}
.dpl-legend {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: #1a7f4b;
  font-weight: 600;
}
.dpl-avatar:hover {
  transform: translateY(-2px);
}
.section-overview.ov.ov button.ov-dpl-more {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 33px;
  height: 33px !important;
  padding: 0 8px;
  border: none;
  border-radius: 17px;
  background: #6b1f4d;
  color: #fff;
  font-size: 11.5px !important;
  font-weight: 700 !important;
}
.dpl-less {
  margin-left: 6px;
}
</style>
